<template>
    <v-row no-gutters>
        <v-col cols="4">
            <v-card flat class="mx-auto" tile>
                <v-card-title>Profile Information</v-card-title>
                <v-card-subtitle>Update your account's profile information and email address.</v-card-subtitle>
            </v-card>
        </v-col>
        <v-col cols="8" class="justify-center">
            <v-form>
                <v-card flat>
                    <v-row>
                        <v-col class="justify-center">
                            <div class="mx-auto text-center">
                                <!-- Review the link and build an avatar menu with the options select new photo, remove photo -->
                                <!-- https://vuetifyjs.com/en/components/avatars/#advanced-usage -->
                                <v-avatar
                                    color="brown"
                                    size="100"
                                >
                                    <img alt="user_profile_photo" src="https://randomuser.me/api/portraits/lego/4.jpg" />
                                </v-avatar>

                                <input
                                    style="display: none"
                                    ref="photoInput"
                                    type="file"
                                    @change="updatePhotoPreview"
                                >
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="form.name"
                                label="Name"
                                hint="Your full name"
                                :error-messages="errors.name"
                            />
                            <v-text-field
                                v-model="form.email"
                                label="Email"
                                hint="Your organization email"
                                :error-messages="errors.email"
                            />
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn depressed color="primary">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-col>
    </v-row>
</template>

<script>
import _ from "lodash";

export default {
    props: {
        user: {
            type: Object,
        }
    },

    data() {
        return {
            form: this.$inertia.form({
                name: this.$props.user.name,
                email: this.$props.user.email,
            })
        };
    },

    methods: {
        updateProfileInformation() {
            this.form.post(route('user-profile-information.update'), {
                errorBag: 'updateProfileInformation',
                preserveScroll: true,
                onSuccess: () => this.clearPhotoFileInput(),
            });
        },

        selectNewPhoto() {
            this.$refs.photoInput.value.click();
        },

        updatePhotoPreview() {
            const photo = this.$refs.photoInput.value.files[0];

            if (! photo) return;

            const reader = new FileReader();

            reader.onload = (e) => {
                // photoPreview.value = e.target.result;
            };

            reader.readAsDataURL(photo);
        },

        deletePhoto() {
            this.$inertia.delete(route('current-user-photo.destroy'), {
                preserveScroll: true,
                onSuccess: () => {
                    this.$refs.photoPreview.value = null;
                    this.clearPhotoFileInput();
                },
            });
        },

        clearPhotoFileInput() {
            if (this.$refs.photoInput.value?.value) {
                this.$refs.photoInput.value.value = null;
            }
        },
    },

    computed: {
        errors() {
            return {
                name: _.get(this.$page, 'props.errors.name', []),
                email: _.get(this.$page, 'props.errors.email', []),
            };
        },
    }
}
</script>

<style scoped>

</style>
